module.exports = __webpack_public_path__ + "img/email-icon.10f852bb.svg";